import React, { useState, useEffect } from "react";
import { useToast } from "@swordsweeper/ssi-ui-component-library";
import SpinningLoader from "@src/components/common/SpinningLoader";
import AccountNotificationSettingsForm from "./AccountNotificationSettingsForm";
import {
  getNotificationSettings,
  updateNotificationSettings,
} from "@src/api/NotificationApi";
import type { NotificationSettings } from "@src/types/notification";

export default function AccountNotificationSettings(): React.JSX.Element {
  const { showToast } = useToast();
  const [
    isLoadingUserNotificationSettings,
    setIsLoadingUserNotificationSettings,
  ] = useState(false);
  const [
    isSavingUserNotificationSettings,
    setIsSavingUserNotificationSettings,
  ] = useState(false);
  const [userNotificationSettings, setUserNotificationSettings] = useState<
    NotificationSettings[] | null
  >(null);

  useEffect(() => {
    handleLoadUserGeneralSettings();
  }, []);

  const handleLoadUserGeneralSettings = async () => {
    setIsLoadingUserNotificationSettings(true);
    try {
      const response = await getNotificationSettings();
      setUserNotificationSettings(response.body);
    } catch (e) {
      console.error(e);
      showToast({
        message: "Error loading user notification settings",
        variant: "error",
      });
    } finally {
      setIsLoadingUserNotificationSettings(false);
    }
  };

  const handleSaveUserNotificationSettings = async (
    formData: NotificationSettings[],
  ) => {
    setIsSavingUserNotificationSettings(true);
    try {
      const response = await updateNotificationSettings(formData);
      setUserNotificationSettings(response.body);
      showToast({
        message: "User notification settings saved",
        variant: "success",
      });
    } catch (e) {
      console.error(e);
      showToast({
        message: "Error saving user notification settings",
        variant: "error",
      });
    } finally {
      setIsSavingUserNotificationSettings(false);
    }
  };

  return (
    <div>
      {(isLoadingUserNotificationSettings ||
        isSavingUserNotificationSettings) && <SpinningLoader />}

      {!!userNotificationSettings && (
        <AccountNotificationSettingsForm
          initialData={userNotificationSettings}
          onSubmit={handleSaveUserNotificationSettings}
        />
      )}
    </div>
  );
}
